import React, { useState, useEffect } from "react";

import { loginRequest, protectedResources } from "../../authConfig";
//import { useGetSkillGroupData, useUpdateSkillGroupData } from '../../hooks/useSkillGroupData';
import { ISkillGroup } from "../../model/SkillGroup.model";
import { IsCookieFunction } from "react-router-dom";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import EditSkillComponent from "./EditSkillComponent";
import { ISkillLevel } from "../../model/SkillLevel.model";
import { ISkill } from "../../model/Skill.model";
import Modal from "../Modal/Modal";
import EditSkillDetailsComponent from "./EditSkillDetailsComponent";
import Loading from '../Loading/Loading';
import "./EditSkillGroupComponent.scss";

const EditSkillGroupAttributesComponent: React.FC<{
  skillGroup: ISkillGroup;
  updateSkillGroupData(event: ISkillGroup): void;
}> = (props: {
  skillGroup: ISkillGroup;
  updateSkillGroupData(event: ISkillGroup): void;
}) => {
    var skillGroup = props.skillGroup;
    console.log("form component w name ", skillGroup.skillGroupName);
    const [name, setName] = useState(skillGroup.skillGroupName);

    //setName(skillGroup.skillGroupName);
    const HandleSubmit = (event: any) => {
      event.preventDefault();
      const formData = new FormData(event.target);
      const inputSN = formData.get("skillGroupName");
      if (inputSN) skillGroup.skillGroupName = inputSN + "";

      props.updateSkillGroupData(skillGroup);
    };
    return (
        <form onSubmit={HandleSubmit} className="dis-flex gap-1 dis-flex-aln-center edit-skill-group-name-form">
          <input type="text" name="skillGroupName" defaultValue={name} className="dis-flex-grow-1" />
          <button className="btn-outlined-primary" type="submit">Update</button>
        </form>
    );
  };

export interface SkillGroupIdComponentState {
  id: any;
  skillGroup: ISkillGroup;
  skillLevels: ISkillLevel[];
  skillGroupDeleted(group:ISkillGroup):void;
}

const EditSkillGroupComponent: React.FC<SkillGroupIdComponentState> = ({
  id,
  skillGroup,
  skillLevels,
  skillGroupDeleted
}) => {
  const [addingSkill, setAddingSkill] = useState(false);
  //const initialData = JSON.parse(JSON.stringify(skillGroup));
  const [group, setGroup] = useState(skillGroup);
  const [skillGroupId, setSkillGroupId] = useState(id);
  const { error, execute } = useFetchWithMsal({
    scopes: protectedResources.apiCFSkillPath.scopes.read,
  });
  const [loading, setLoading] = useState(false);
  const [showDeleteGroup, updateShowDeleteGroup] = useState(false);
  const [callErr, setErr] = useState(null);
  const [maxIndex, setMaxIndex] = useState(0);
  const [newSkill, setNewSkill] = useState({
    SkillId: "",
    skillGroupId: skillGroupId,
    indexNumber: maxIndex,
    skillName: "",
    skillDescription: "",
    createdDate: "",
    CreatedBy: "",
    lastModifiedDate: "",
    lastModifiedBy: "",
  })

  const handleEditAttributesTask = (skillGroupUpdated: ISkillGroup) => {
    execute("PUT", `/api/SkillGroup/updateSkillGroup`, skillGroupUpdated)
      .then((response: any) => {
        setGroup(response);
        setLoading(false);
      })
      .catch((err: any) => {
        setErr(err);
        setLoading(false);
      });
  };
  const generateMaxIndex = () => {
    if (!group || !group.skills) return;
    let i = group.skills.reduce((v, sl) => { if (sl.indexNumber > v) return sl.indexNumber; return v; }, 0);
    if (i !== maxIndex) setMaxIndex(i);
  }
  generateMaxIndex();
  const openAddSkill = () => {
    let newSkill: ISkill | any = {
      SkillId: "",
      skillGroupId: skillGroupId,
      indexNumber: maxIndex + 1,
      skillName: "",
      skillDescription: "",
      createdDate: "",
      CreatedBy: "",
      lastModifiedDate: "",
      lastModifiedBy: "",
      skills: []
    };
    setNewSkill(newSkill);
    setAddingSkill(true);
  };
  const handleUpdateSkillData = (event: any) => {

  }
  const HandleSkillDeleted = (deleteSkill:ISkill) => {
    if (skillGroup.skills) {
      skillGroup.skills.splice(skillGroup.skills.indexOf(deleteSkill), 1);
      setGroup(JSON.parse(JSON.stringify(skillGroup)));
    }
  }
  const HandleMoveSkillUp = async (skill: ISkill, index: number) => {
    setLoading(true);
    var skill1 = skill;
    if (!skillGroup || !skillGroup.skills) return;
    var skill2 = skillGroup.skills[index-1];
    if (!skill2) return;
    if (skill1.indexNumber===skill2.indexNumber) {
      alert('duplicate index numbers - ' + skill1.indexNumber);
      return;
    }
    let intindexnum = skill2.indexNumber;
    skill2.indexNumber = skill1.indexNumber;
    skill1.indexNumber = intindexnum;
    await UpdateSkillData(skill1);
    await UpdateSkillData(skill2);
    var sorted = skillGroup.skills.sort((a, b) => {
      if (a.indexNumber < b.indexNumber) return -1;
      if (a.indexNumber===b.indexNumber) return 0;
      return 1;
    });
    skillGroup.skills = sorted;
  }
  const UpdateSkillData = async (skill:ISkill) => {
    execute("PUT", `/api/Skill/updateSkill`, skill)
    .then((response:any) => {
      skill = response;
      setLoading(false);
    }).catch((err:any) => {
      setErr(err);
      setLoading(false);
    })
  }
  const handleAddNewSkillData = (skill: ISkill) => {
    execute("POST", `/api/Skill/addSkill`, skill)
      .then((response: any) => {
        //setItem(response);
        let sk = response;
        sk.skills = [];
        skillGroup.skills?.push(sk);
        generateMaxIndex();
        setNewSkill(sk);
        setLoading(false);
      })
      .catch((err: any) => {
        setErr(err);
        setLoading(false);
      });
    //setAddingSkill(false);
  }
  const closeAddSkill = () => {
    setAddingSkill(false);
  }
  const getEditSkillModalTitle = (skillGroupName:string) => {
    const skillsIndex = skillGroupName.toLowerCase().indexOf("skills");
    const skillIndex = skillGroupName.toLowerCase().indexOf("skill");
    switch(true){
      case skillIndex !== -1 && skillsIndex !== -1:
        return "New " + skillGroupName.slice(0, -1);
      case skillIndex !== -1 && skillsIndex === -1:
        return "New " + skillGroupName;
      default:
        return "New " + skillGroupName + " Skill";
    }
  }
  const toggleDeleteGroup = (show:boolean) => {
    updateShowDeleteGroup(show);
  }
  const DeleteTheGroup = () => {
    execute("DELETE", `/api/SkillGroup/deleteSkillGroup/${skillGroupId}`)
    .then((response: any) => {
      //setItem(response);
      let sk = response;
      skillGroupDeleted(group);
      setLoading(false);
    })
    .catch((err: any) => {
      setErr(err);
      setLoading(false);
    });
  }
  return (
    <div className="adminSkillGroup">
      <Loading isLoading={loading} />
      <>
        <EditSkillGroupAttributesComponent
          skillGroup={group}
          updateSkillGroupData={handleEditAttributesTask}
        />
      </>
      <div className="dis-flex-grow-1">
        <ul className="reset">
        {group.skills &&
          group.skills.length > 0 &&
          group.skills.map((item: any, skillIndex:number) => (
            <li className="m-b--50">
              <EditSkillComponent id={item.skillId} Skill={item} SkillLevels={skillLevels} index={skillIndex} skillDeleted={HandleSkillDeleted} moveSkillUp={HandleMoveSkillUp} />
            </li>
          ))}
          </ul>
      </div>

      <div className="aln-center">
        <button className="btn-secondary" onClick={openAddSkill}>Add Skill</button>&nbsp;
        <button className="btn-secondary" disabled={skillGroup.skills &&
          skillGroup.skills.length > 0} onClick={e => toggleDeleteGroup(true)}>Delete Group</button>
      </div>
          <Modal isOpen={showDeleteGroup} onClose={() => toggleDeleteGroup(false)}><>
          <p>Are you sure you want to delete this group?</p>
          <div className="dis-flex dis-flex-jst-center gap--50">
            <button className='btn-outlined-secondary-sml' onClick={(e) => DeleteTheGroup()} title='Delete Skill Group'>
              Yes
            </button>
            <button className='btn-outlined-secondary-sml' onClick={(e) => toggleDeleteGroup(false)} title='Cancel'>
              No
            </button>
            </div>
          </></Modal>
        {addingSkill && (
          <>
            <div className="aln-center" role="region" id="addingSkill" aria-live="polite"><i>Adding Skill</i></div>
            <Modal isOpen={addingSkill} modalTitle={getEditSkillModalTitle(group.skillGroupName)} hasCloseBtn={true} onClose={closeAddSkill}>
              <EditSkillDetailsComponent Skill={newSkill} SkillLevels={skillLevels} addNewSkillData={handleAddNewSkillData} updateSkillData={handleUpdateSkillData} />
            </Modal>
          </>)}
      
    </div>

  );
};
export default EditSkillGroupComponent;
